window.jQuery = window.$ = require("jquery");
window.WebFont = require("webfontloader");
require("@popperjs/core");
require("bootstrap");
require("jquery-mask-plugin");
